export default __webpack_public_path__ + "static/media/img7.205c7c5c.png";